import { PropTypes } from 'prop-types';
import React from 'react';

import * as basePropTypes from 'src/constants/propTypes/base';

import BaseModal from 'src/components/modals/Base';
import HorizontalLine from 'src/components/HorizontalLine';

import styles from './styles.module.scss';
import SubmitButton from './SubmitButton';

function ConfirmationModal(props) {
  const {
    children,
    closeModal,
    extraClasses,
    isActive,
    isPositiveAction,
    submitAction,
    submitActionName,
    title,
  } = props;

  const containerClass = [styles.Container, extraClasses && extraClasses.container]
    .filter(Boolean)
    .join(' ');

  return (
    <BaseModal
      closeModal={ closeModal }
      dataAutomatedTest="confirmation-modal"
      extraClasses={ { container : containerClass } }
    >
      <If condition={ title !== false }>
        <h3 className={ styles.Title }>{ title || 'Are you sure?' }</h3>
      </If>

      <div className={ styles.Para }>
        { children }
      </div>

      <div className={ styles.Buttons }>
        <div className={ styles.HorizontalLine }><HorizontalLine /></div>

        <SubmitButton
          isActive={ isActive }
          isPositiveAction={ isPositiveAction }
          submitAction={ submitAction }
          submitActionName={ submitActionName }
        />

        <div className={ styles.HorizontalLine }><HorizontalLine /></div>

        <div
          className={ styles.CancelButton }
          onClick={ closeModal }
        >
          <p>Cancel</p>
        </div>
      </div>
    </BaseModal>
  );
}

ConfirmationModal.propTypes = {
  children         : basePropTypes.children.isRequired,
  closeModal       : basePropTypes.closeModal.isRequired,
  extraClasses     : basePropTypes.extraClasses,
  isActive         : basePropTypes.isActive,
  isPositiveAction : basePropTypes.isPositiveAction,
  submitAction     : basePropTypes.submitAction.isRequired,
  submitActionName : basePropTypes.submitActionName.isRequired,
  title            : PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default ConfirmationModal;
